/* Sleep Better Tonight V4. No dependencies, network calls, customer-data tracking or storage. */
(() => {
  'use strict';
  if (customElements.get('gf-sleep-page')) return;
  const REVIEWS = [
  {
    "name": "Anna Stevens",
    "excerpt": "The delivery guys were professional and courteous. We enjoyed the new mattress and sleep well.",
    "full": "The delivery guys were professional and courteous. We enjoyed the new mattress and sleep well. We will recommend Gallery Furniture to all our friends and family. Very satisfied customer.\nCole and Anna Stevens"
  },
  {
    "name": "Caleb Grable",
    "excerpt": "Wish I would have started here but so glad I got my mattress from here. It’s the best and I’ve never slept better.",
    "full": "Best experience at a furniture store and I’ve been going to them a lot lately to buy new furniture for moving. Wish I would have started here but so glad I got my mattress from here. It’s the best and I’ve never slept better.\n\nThe whole process from start to finish was amazing. The staff at GF were amazing, kind, and knowledgeable. They weren’t pushy and right on top of you to make a sale like most stores would be. The delivery guy were great and polite. Got a call the next day from Mr. Mac himself asking me how my experience was and if everything with delivery was good. Of course it was a yes! Definitely will be back."
  },
  {
    "name": "YoToshia Bellow",
    "excerpt": "The salesman John was very nice and got us in and out and we slept well on our mattress that night",
    "full": "First of all there were scooters for kids and adults it was hot and water and cake was offered. The salesman John was very nice and got us in and out and we slept well on our mattress that night 🌙 😴"
  },
  {
    "name": "Pamela Porteous",
    "excerpt": "My new Tempur pedic sleeps like I am on a cloud!!",
    "full": "Couldn’t ask for a more perfect experience great sales people and the best selection of mattresses ever!! My new Tempur pedic sleeps like I am on a cloud!!"
  },
  {
    "name": "Bridgett Webber",
    "excerpt": "We tested out several mattresses and ultimately decided on a Tempur Pedic, which, based on my sleep last night, was an excellent decision!",
    "full": "What a wonderful experience at Gallery Furniture! Our salesperson Steve was very welcoming and knowledgeable and did not make us feel rushed or pressured to make a decision, which I appreciated. We tested out several mattresses and ultimately decided on a Tempur Pedic, which, based on my sleep last night, was an excellent decision! We purchased it around 1pm and it was delivered at 7pm. The delivery team was very fast and professional. If you are looking for a mattress or furniture I highly recommend Gallery Furniture."
  },
  {
    "name": "Ricci Crutchfield",
    "excerpt": "The delivery guys were absolutely fantastic. Courteous, professional & know their limits with the truck!",
    "full": "Great experience. Got our mattress that same evening & have great sleep enter since! The delivery guys were absolutely fantastic. Courteous, professional & know their limits with the truck!"
  }
];

  class GFSleepPage extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cleanup = [];
      this.on = (target, event, handler, options = {}) => {
        target.addEventListener(event, handler, { ...options, signal: this.controller.signal });
      };
      this.initReviews();
      this.initNativeForm();
    }

    disconnectedCallback() {
      this.querySelector('dialog[open]')?.close();
      this.controller?.abort();
      this.cleanup?.forEach(fn => fn());
      this.controller = null;
    }

    find(name) { return this.querySelector(`[data-sbt="${name}"]`); }

    initReviews() {
      const track = this.find('reviews-track');
      if (!track) return;
      const previous = this.find('reviews-prev');
      const next = this.find('reviews-next');
      const count = this.find('reviews-count');
      const dialog = this.find('review-dialog');
      const section = this.querySelector('.sbt-reviews');
      const autoplay = this.find('reviews-autoplay');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = matchMedia('(min-width: 601px)');
      const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      const configured = this.dataset.autoplay !== 'false';
      let playing = configured && !motion.matches;
      let hovering = false;
      let inView = false;
      let lastInteraction = 0;
      let opener;
      track.replaceChildren();
      REVIEWS.forEach((review, i) => {
        const card = document.createElement('article');
        card.className = 'sbt-review-card';
        card.setAttribute('aria-roledescription', 'slide');
        card.setAttribute('aria-label', `Review ${i + 1} of ${REVIEWS.length}: ${review.name}`);
        const stars = document.createElement('p');
        stars.className = 'sbt-review-stars';
        stars.setAttribute('aria-label', '5 out of 5 stars');
        stars.innerHTML = '<span aria-hidden="true">★★★★★</span>';
        const quote = document.createElement('blockquote');
        quote.textContent = `“${review.excerpt}”`;
        const name = document.createElement('p');
        name.className = 'sbt-review-card__name';
        name.textContent = review.name;
        const read = document.createElement('button');
        read.type = 'button';
        read.className = 'sbt-review-card__read';
        read.textContent = 'Read full review';
        read.setAttribute('aria-label', `Read full review by ${review.name}`);
        read.setAttribute('aria-haspopup', 'dialog');
        this.on(read, 'click', () => {
          opener = read;
          this.find('review-dialog-name').textContent = review.name;
          this.find('review-dialog-text').textContent = review.full;
          dialog.showModal();
          dialog.scrollTop = 0;
        });
        card.append(stars, quote, name, read);
        track.append(card);
      });
      const cards = [...track.children];
      const state = () => {
        const visible = Math.min(REVIEWS.length, desktop.matches ? 2 : 1);
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const index = Math.max(0, Math.min(REVIEWS.length - visible, Math.round(track.scrollLeft / step)));
        return { visible, step, index };
      };
      const update = () => {
        const { visible, index } = state();
        previous.disabled = index === 0;
        next.disabled = index >= REVIEWS.length - visible;
        count.textContent = visible === 1 ? `${index + 1} of ${REVIEWS.length}` : `${index + 1} to ${index + visible} of ${REVIEWS.length}`;
        cards.forEach((card, i) => { card.inert = i < index || i >= index + visible; });
      };
      const move = direction => {
        const { visible, step, index } = state();
        const target = Math.max(0, Math.min(REVIEWS.length - visible, index + direction));
        track.scrollTo({ left: target * step, behavior: motion.matches ? 'instant' : 'smooth' });
      };
      const touch = () => { lastInteraction = Date.now(); };
      this.on(previous, 'click', () => move(-1));
      this.on(next, 'click', () => move(1));
      this.on(track, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.on(track, 'scroll', update, { passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      this.cleanup.push(() => resize.disconnect());
      this.on(dialog.querySelector('.sbt-review-dialog__close'), 'click', () => dialog.close());
      this.on(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      this.on(dialog, 'close', () => opener?.focus({ preventScroll: true }));
      const playback = () => {
        autoplay.textContent = playing ? 'Pause' : 'Play';
        autoplay.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} automatic review slideshow`);
        count.setAttribute('aria-live', playing ? 'off' : 'polite');
      };
      this.on(autoplay, 'click', () => { playing = !playing; touch(); playback(); });
      this.on(section, 'pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; });
      this.on(section, 'pointerleave', () => { hovering = false; touch(); });
      ['pointerdown','keydown','focusout'].forEach(e => this.on(section, e, touch));
      this.on(document, 'visibilitychange', touch);
      const intersection = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        if (inView) touch();
      }, { threshold: 0.25 });
      intersection.observe(section);
      this.cleanup.push(() => intersection.disconnect());
      this.on(motion, 'change', () => { playing = configured && !motion.matches; playback(); });
      const timer = setInterval(() => {
        const focused = section.contains(document.activeElement) && document.activeElement !== autoplay;
        if (!playing || !inView || hovering || focused || dialog.open || document.hidden || Date.now() - lastInteraction < interval) return;
        const { visible, step, index } = state();
        const target = index >= REVIEWS.length - visible ? 0 : index + 1;
        touch();
        track.scrollTo({ left: target * step, behavior: motion.matches ? 'instant' : 'smooth' });
      }, 250);
      this.cleanup.push(() => clearInterval(timer));
      playback();
      update();
    }

    initNativeForm() {
      // Only the native Shopify contact form. App forms own validation and delivery.
      const fieldset = this.find('sleep-form-fields');
      if (!fieldset) {
        this.querySelector('[data-sbt-contact-success],[data-sbt-contact-errors]')?.focus();
        return;
      }
      const form = fieldset.closest('form');
      const phone = this.find('sleep-phone');
      const names = [this.find('sleep-first-name'), this.find('sleep-last-name')];
      const validate = () => {
        const digits = phone.value.replace(/\D/g,'');
        phone.setCustomValidity(phone.value && !(digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))) ? 'Enter a 10-digit phone number, with an optional +1 country code.' : '');
        names.forEach(input => input.setCustomValidity(input.value && !input.value.trim() ? 'Please enter your name.' : ''));
      };
      this.on(phone, 'input', validate);
      names.forEach(input => this.on(input, 'input', validate));
      this.on(form, 'submit', event => {
        validate();
        if (!form.reportValidity()) event.preventDefault();
        // Valid entries POST normally through Shopify. Never synthesize a success state.
      });
      this.querySelector('[data-sbt-contact-errors]')?.focus();
    }
  }
  customElements.define('gf-sleep-page', GFSleepPage);
})();
